import LayoutAdmin from "@/ux/admin/layoutAdmin/LayoutAdmin.vue";
import DeliveriesView from "@/ux/admin/deliveries/DeliveriesView.vue"
import CreateEditDeliveryView from "@/ux/admin/createEditDelivery/CreateEditDeliveryView.vue"
import ClientsView from "@/ux/admin/clients/ClientsView.vue"
import CreateEditClientView from "@/ux/admin/createEditClient/CreateEditClientView.vue"
import LoginView from "@/ux/admin/login/LoginView.vue"

export const adminRoutes = [
  {
    path: "/administrator/login",
    name: "login",
    component: LoginView
  },
  {
    path: "/administrator",
    component: LayoutAdmin,
    redirect: "/administrator/clients",
    children: [
      {
        path: "clients",
        name: "clients",
        component: ClientsView,
      },
      {
        path: "client/:id?",
        name: "client",
        component: CreateEditClientView,
        props: true,
      },
      {
        path: "delivery",
        name: "delivery",
        component: CreateEditDeliveryView,
      },
      {
        path: "deliveries",
        name: "deliveries",
        component: DeliveriesView,
      }
    ],
  },
];